export function getCallMode(element: { appType: string; recordEventType?: string; type?: string }) {
  switch (element.appType || element.recordEventType || element.type) {
    case 'WIDGET':
      return 'CALLING_MODE.WIDGET';
    case 'MOBILE':
      return 'CALLING_MODE.MOBILE';
    case 'ZENDESK':
      return 'CALLING_MODE.ZENDESK';
    case 'WEB_WIDGET':
      return 'CALLING_MODE.WEB_WIDGET';
    case 'INCOMING_CALL_REDIRECTED':
      return 'CALLING_MODE.INCOMING_CALL_REDIRECTED';
    case 'VOICE_MAIL_DROP':
      return 'CALLING_MODE.VOICE_MAIL_DROP';
    default:
      return '';
  }
}
